import flatten from 'lodash-es/flatten';
import React from 'react';
import adjustVerticalTextAlignments from '../../feasibility/exports/adjustVerticalTextAlignment';
import {
  GraphExportType,
} from '../../Utils';
import {
  Layout,
} from '../../workerStore/stack/Utils';
import getTicksInfo from '../chart/getTicksInfo';
import {
  axisColor,
  axisThickness,
  gridlineColor,
  gridlineThickness,
  tickColor,
  tickLabelSeparationFromAxis,
  tickLength,
  tickThickness,
} from './Utils';

interface IProps {
  xAxisMax: number;
  xAxisMin: number;
  yAxisMax: number;
  yAxisMin: number;
  layout: Layout;
  width: number;
  height: number;
  exportType: GraphExportType;
}

export default class extends React.PureComponent<IProps> {
  render() {
    const {
      width, height,
      xAxisMin, xAxisMax, yAxisMin, yAxisMax,
      layout, exportType,
    } = this.props;

    const needTextAdjustment = (exportType === GraphExportType.PDF);

    const {xTicks, yTicks} = getTicksInfo({
      svgWidth: width, svgHeight: height,
      xAxisMin, xAxisMax, yAxisMin, yAxisMax, layout,
    });

    const xTickLabelYCoord = height + tickLabelSeparationFromAxis;

    const xTickElems = xTicks.map(({position, label}, index) => {
      const {y, alignmentBaseline} = adjustVerticalTextAlignments(
        needTextAdjustment, xTickLabelYCoord, 'hanging',
      );
      return [
        (
          <line x1={position} y1={height} x2={position} y2={height + tickLength}
            key={`${index}-tick`} stroke={tickColor} strokeWidth={tickThickness}/>
        ),
        (
          <text textAnchor='end'
            transform={`translate(${position}, ${y}) rotate(-65)`}
            alignmentBaseline={alignmentBaseline} key={`${index}-label`}>
            {label}
          </text>
        ),
      ];
    });

    const yTickLabelXCoord = - tickLabelSeparationFromAxis;

    const yTickElems = yTicks.map(({position, label}, index) => {
      const {y, alignmentBaseline} = adjustVerticalTextAlignments(
        needTextAdjustment, position, 'middle',
      );
      return [
        (
          <line x1={-tickLength} y1={position} x2={0} y2={position} key={index}
            stroke={tickColor} strokeWidth={tickThickness}/>
        ),
        (
        <text textAnchor='end'
          transform={`translate(${yTickLabelXCoord}, ${y})`}
          alignmentBaseline={alignmentBaseline} key={`${index}-label`}>
          {label}
        </text>
        ),
      ];
    });

    const horizontalGridlines = yTicks.map(({position}, index) => (
      <line x1={0} y1={position} x2={width} y2={position}
        key={`${index}-horizontal`} stroke={gridlineColor} strokeWidth={gridlineThickness}/>
    ));

    const verticalGridlines = xTicks.map(({position}, index) => (
      <line x1={position} y1={0} x2={position} y2={height}
        key={`${index}-vertical`} stroke={gridlineColor} strokeWidth={gridlineThickness}/>
    ));

    const xAxis = (
      <line x1={0} y1={height} x2={width} y2={height} strokeWidth={axisThickness} stroke={axisColor}/>
    );

    const yAxis = (
      <line x1={0} y1={0} x2={0} y2={height} strokeWidth={axisThickness} stroke={axisColor}/>
    );

    return (
      <>
        <g>{flatten(xTickElems)}</g>
        <g>{flatten(yTickElems)}</g>
        <g>{horizontalGridlines}</g>
        <g>{verticalGridlines}</g>
        <g>{xAxis}{yAxis}</g>
      </>
    );
  }
}
